import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import CustomerServices from './customer_services';

export const GetAllUsers = createAsyncThunk(
  'customers/get_all_users',
  async (requestData, thunkAPI) => {
    try {
      const response = await CustomerServices.getAllCustomer(requestData);

      return response;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetSingleCustomer = createAsyncThunk(
  'customers/get_single_user',
  async (requestData, thunkAPI) => {
    try {
      const response = await CustomerServices.getSingleCustomer(requestData);

      return response;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetTotalUserCount = createAsyncThunk(
  'customers/get_user_total_count',
  async (_, thunkAPI) => {
    try {
      const response = await CustomerServices.getTotalUserCount();

      return response;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetSearchData = createAsyncThunk(
  'customers/get_user_search_data',
  async (payload, thunkAPI) => {
    try {
      const response = await CustomerServices.getSearchCustomer(payload);

      return response;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);
